import React from "react";
import "./EqualWidthList.scss";
import { TextInputComponent } from "..";
import CustomTooltip from "../custom-tooltip";
import ContactLink from "../contact-link/contact-link";

interface EqualWidthListProps {
  label: string;
  labelValue?: string;
  className?: string;
  type?: "Email" | "Phone" | "website";
  enableTooltip?: boolean;
}

const EqualWidthList: React.FC<EqualWidthListProps> = ({
  label,
  labelValue,
  className,
  type,
  enableTooltip = false,
}) => {
  const contentSpan = (
    <span
      className={`item-value ${enableTooltip ? "item-value--ellipsis" : ""} ${className || ""}`}
    >
      {labelValue ?? "-"}
    </span>
  );
  const content = enableTooltip && labelValue && labelValue !== "-" ? (
    <CustomTooltip title={labelValue} placement="top">
      {contentSpan}
    </CustomTooltip>
  ) : (
    contentSpan
  );
  return (
    <ul className="equal-width-list">
      <li className="list-item">
        <span className="item-label">{label} </span>
        {type && labelValue && labelValue !== "-" ? (
          enableTooltip ? (
            <CustomTooltip title={labelValue} placement="top">
              <span className={`item-value item-value-wrapper--ellipsis ${className || ""}`}>
                <ContactLink
                  type={type || "Email"}
                  value={labelValue || ""}
                  className={`item-value-link--ellipsis`}
                />
              </span>
            </CustomTooltip>
          ) : (
            <ContactLink
              type={type || "Email"}
              value={labelValue || ""}
              className={`item-value ${className || ""}`}
            />
          )
        ) : enableTooltip && labelValue && labelValue !== "-" ? (
          content
        ) : (
          <span className={`item-value ${className || ""}`}>{labelValue ?? "-"}</span>
        )}
      </li>
    </ul>
  );
};

export default EqualWidthList;
